import {
  Drawer,
  Sheet,
  DialogTitle,
  ModalClose,
  List,
  ListItem,
  Button,
  Stack,
  Divider,
  Select,
  Option,
  SvgIcon,
  Input,
  Typography,
  FormHelperText,
  Checkbox,
  FormControl
} from '@mui/joy';

import { DeleteForever } from '@mui/icons-material';
import { useTranslateText } from '../../lib/ai';
import { useEffect, useState } from 'react';
import { useGetValueByKeyByGroup } from '../../lib/values';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { LOCALES_SHORT } from '../../constants/defaults';
import { DEFAULT_LOCALE, LOCALES } from '../../constants/defaults';
//import { useUpdateLandingPage, useGetLandingPage } from '../../lib/landing-pages';
import { useGetTripById, usePatchTrip, useGetFAQByTrip, usePatchAllFAQ } from '../../lib/trip';
import slugify from 'slugify';

const actions = [{ value: 'translate', label: 'Translate' }];

// Función auxiliar para reparar JSONs truncados o malformados
// const repairMalformedJson = (jsonString) => {
//   let repaired = jsonString.trim();
//   
//   // Si el JSON no termina con }, probablemente está truncado
//   // Intentar cerrar objetos y arrays abiertos
//   let openBraces = (repaired.match(/{/g) || []).length;
//   let closeBraces = (repaired.match(/}/g) || []).length;
//   let openBrackets = (repaired.match(/\[/g) || []).length;
//   let closeBrackets = (repaired.match(/\]/g) || []).length;
//   
//   // Cerrar arrays abiertos primero
//   for (let i = 0; i < openBrackets - closeBrackets; i++) {
//     repaired += ']';
//   }
//   
//   // Cerrar objetos abiertos
//   for (let i = 0; i < openBraces - closeBraces; i++) {
//     repaired += '}';
//   }
//   
//   // Si terminamos dentro de un string sin cerrar, intentar cerrarlo
//   let inString = false;
//   let escapeNext = false;
//   let lastQuotePos = -1;
//   
//   for (let i = 0; i < repaired.length; i++) {
//     const char = repaired[i];
//     
//     if (escapeNext) {
//       escapeNext = false;
//       continue;
//     }
//     
//     if (char === '\\') {
//       escapeNext = true;
//       continue;
//     }
//     
//     if (char === '"') {
//       if (inString) {
//         inString = false;
//         lastQuotePos = i;
//       } else {
//         inString = true;
//         lastQuotePos = i;
//       }
//     }
//   }
//   
//   // Si terminamos dentro de un string, cerrarlo
//   if (inString) {
//     // Buscar el último } o ] para insertar la comilla antes
//     const lastBrace = Math.max(
//       repaired.lastIndexOf('}'),
//       repaired.lastIndexOf(']')
//     );
//     
//     if (lastBrace > lastQuotePos) {
//       // Insertar comilla antes del cierre
//       repaired = repaired.substring(0, lastBrace) + '"' + repaired.substring(lastBrace);
//     } else {
//       // Simplemente cerrar el string al final
//       repaired = repaired + '"';
//     }
//   }
//   
//   return repaired;
// };

const TripBulk = ({ bulkPage, open, setOpen }) => {

  const queryClient = useQueryClient();

  const [csvStatics, setCsvStatics] = useState({});

  const [openOptions, setOpenOptions] = useState(false);
  const [fromLanguage, setFromLanguage] = useState(DEFAULT_LOCALE);
  const [toLanguage, setToLanguage] = useState(null);
  const [glossary, setGlossary] = useState('');
  const [translating, setTranslating] = useState(false);

  const [bulk, setBulk] = useState(bulkPage);
  const [changeslug, setChangeslug] = useState(false);

  const [changecontent, setChangecontent] = useState(false);
  const [changecontentConfirmed, setChangecontentConfirmed] = useState(false);

  const { refetch } = useQuery(
    [`value`],
    async () => {
      try {
        return await useGetValueByKeyByGroup(
          'TRANSLATE_GLOSSARIES',
          `${LOCALES_SHORT[fromLanguage]}_${LOCALES_SHORT[toLanguage]}`
        );
      } catch (e) {
        return true;
      }
    },
    {
      enabled: false
    }
  );

  const handleTranslate = async () => {
    setTranslating(true);
    setCsvStatics((prev) => ({ ...prev, success: 0, error: 0, errorMessages: [], infoMessages: [] })); // Limpiar resultados anteriores
    window.onbeforeunload = function () {
      return 'Translate working ...';
    };

    for (const page of bulk) {
      // Validación de ID del trip
      if (!page._id || page._id.trim() === '' || isNaN(parseInt(page._id))) {
        page.success = false;
        const errorMessage = `Trip (ID: ${page._id || 'N/A'}) - invalid ID`;
        page.comment = 'invalid ID';
        setCsvStatics((prev) => ({ 
          ...prev, 
          error: (prev.error || 0) + 1,
          errorMessages: [...(prev.errorMessages || []), errorMessage]
        }));
        continue;
      }

      try {
        // Obtener el trip por ID
        const trip = await queryClient.fetchQuery({
          queryKey: [`trip-${page._id}`],
          queryFn: async () => {
            try {
              return await useGetTripById(parseInt(page._id));
            } catch (e) {
              page.success = false;
              page.comment = 'not found';
              return false;
            }
          }
        });

        if (!trip) {
          // Si el trip no existe, se marca como fallido y se continúa con el siguiente trip
          page.success = false;
          const errorMessage = `Trip (ID: ${page._id}) - not found`;
          page.comment = 'not found';
          setCsvStatics((prev) => ({ 
            ...prev, 
            error: (prev.error || 0) + 1,
            errorMessages: [...(prev.errorMessages || []), errorMessage]
          }));
          continue;
        }

        const tripInfo = trip.i18n;
        // Validación de datos del trip
        if (!tripInfo) {
          page.success = false;
          const errorMessage = `Trip (ID: ${page._id}) - no i18n data`;
          page.comment = 'no i18n data';
          setCsvStatics((prev) => ({ 
            ...prev, 
            error: (prev.error || 0) + 1,
            errorMessages: [...(prev.errorMessages || []), errorMessage]
          }));
          continue;
        }

        const existingTitle = tripInfo[toLanguage]?.title;
        // Validación de existencia de traducción en el idioma destino
        const hasExistingTranslation = existingTitle !== undefined && existingTitle !== null && existingTitle !== '';

        if (!changecontentConfirmed && hasExistingTranslation) {
          page.success = false;
          const infoMessage = `Trip (${page._id} - ${existingTitle}) was not translated because overwrite was not selected`;
          page.comment = infoMessage;
          setCsvStatics((prev) => ({ 
            ...prev, 
            infoMessages: [...(prev.infoMessages || []), infoMessage]
          }));
          continue;
        }

        //const toTranslate = tripInfo[fromLanguage];
        const { link, ...rest } = tripInfo[fromLanguage];
        const toTranslate = JSON.parse(JSON.stringify(rest));
        if (!toTranslate) {
          page.success = false;
          const errorMessage = `Trip (ID: ${page._id}) - no content in ${fromLanguage}`;
          page.comment = `no content in ${fromLanguage}`;
          setCsvStatics((prev) => ({ 
            ...prev, 
            error: (prev.error || 0) + 1,
            errorMessages: [...(prev.errorMessages || []), errorMessage]
          }));
          continue;
        }

        const originalLink = link || '';
        toTranslate.temp_slug = originalLink
          .replace('https://www.explore-share.com/trip/', '')
          .replaceAll('-', ' ')
          .replaceAll('/', ' ');

        let translate;
        let jsonResponse;
        try {
          translate = await useTranslateText({
            template: `
        I am an expert translator. My goal is to provide the best translation possible. I will translate your text from ${LOCALES[fromLanguage]} to ${LOCALES[toLanguage]}.
        In the JSON, I will find words that are between curly braces like {{ location }}, this words are variables and I don't have to be translate them, they must be kept them in the original language.
        I have a glossary with the words and their translations also indication for get a best translation, and I will use it to translate the text.
      `,
            query: `
        Please, translate this JSON to ${LOCALES[toLanguage]}, translate only the values and not the keys. Respond with the same json but translated. And remember, you need to use the glossary for the translation.
        IMPORTANT: 
        - You must return a valid JSON object. 
        - All quotes inside string values must be properly escaped with backslashes (\\\\"). 
        - Do not use typographic quotes inside the JSON strings. 
        - Use only standard double quotes for JSON syntax and escape any quotes inside the string values.
        - Do NOT add any extra characters, separators, dashes, or decorative elements to the translated values.
        - Preserve the exact format and structure of the original JSON - only translate the text content, nothing else.
        - Do not add trailing dashes, underscores, or any other characters to field values.
      `,
            data: JSON.stringify(toTranslate),
            glossary
          });

          if (!translate.ok) {
            const errorText = await translate.text();
            throw new Error(`Translation service error: ${translate.status} ${translate.statusText}`);
          }

          try {
            const responseData = await translate.json();
            jsonResponse = responseData.response;
          } catch (e) {
            throw e;
          }
        } catch (e) {
          throw e;
        }

        let parsedResponse;
        try {
          // Limpiar el JSON de diferentes formatos de markdown
          let cleanedJson = jsonResponse.trim();
          
          // Remover bloques de código markdown (diferentes variantes)
          cleanedJson = cleanedJson.replace(/^```(?:json|JSON)?\s*\n?/i, '');
          cleanedJson = cleanedJson.replace(/\n?```\s*$/i, '');
          cleanedJson = cleanedJson.trim();
          
          // Si el JSON está envuelto en comillas adicionales, intentar extraerlo
          if ((cleanedJson.startsWith('"') && cleanedJson.endsWith('"')) || 
              (cleanedJson.startsWith("'") && cleanedJson.endsWith("'"))) {
            try {
              // Intentar parsear como string JSON primero
              const unquoted = JSON.parse(cleanedJson);
              if (typeof unquoted === 'string') {
                cleanedJson = unquoted;
              }
            } catch (e) {
              // Si falla, continuar con el JSON original
            }
          }
          
          // Intentar extraer el JSON válido si hay texto adicional
          // Buscar el primer { y el último } que formen un JSON válido
          const firstBrace = cleanedJson.indexOf('{');
          if (firstBrace !== -1) {
            // Encontrar el último } que cierre el JSON
            let braceCount = 0;
            let lastBrace = -1;
            for (let i = firstBrace; i < cleanedJson.length; i++) {
              if (cleanedJson[i] === '{') braceCount++;
              if (cleanedJson[i] === '}') {
                braceCount--;
                if (braceCount === 0) {
                  lastBrace = i;
                  break;
                }
              }
            }
            if (lastBrace !== -1) {
              // JSON completo encontrado
              cleanedJson = cleanedJson.substring(firstBrace, lastBrace + 1);
            } else {
              // JSON truncado - extraer desde el primer { hasta el final
              cleanedJson = cleanedJson.substring(firstBrace);
            }
          }
          
          // Intentar parsear el JSON
          try {
            parsedResponse = JSON.parse(cleanedJson);
          } catch (parseError) {
            // Si falla, intentar reparar el JSON truncado o malformado
            // console.warn('Primer intento de parseo falló, intentando reparar JSON...', {
            //   error: parseError.message
            // });
            
            // try {
            //   const repairedJson = repairMalformedJson(cleanedJson);
            //   parsedResponse = JSON.parse(repairedJson);
            //   console.log('JSON reparado exitosamente');
            // } catch (repairError) {
            // Si la reparación también falla, lanzar el error original con más contexto

            // esto se elimina luego de pruebas 
            console.error('Error parsing JSON response:', {
              originalError: parseError.message,
              // repairError: repairError.message,
              jsonLength: jsonResponse?.length,
              cleanedJsonLength: cleanedJson?.length,
              jsonPreview: jsonResponse?.substring(0, 500),
              jsonEnd: jsonResponse?.substring(Math.max(0, jsonResponse.length - 200))
            });
            
            throw new Error(`Error al parsear la respuesta JSON de traducción: ${parseError.message}. La respuesta puede estar truncada.`);
            // }
          }
        } catch (e) {
          // Log detallado del error para debugging
          const errorPosition = e.message.match(/position (\d+)/)?.[1];
          const position = errorPosition ? parseInt(errorPosition) : null;
          
          console.error('Error parsing JSON response:', {
            error: e.message,
            position: errorPosition,
            jsonLength: jsonResponse?.length,
            jsonPreview: jsonResponse?.substring(0, 500),
            errorContext: position ? jsonResponse?.substring(Math.max(0, position - 50), Math.min(jsonResponse.length, position + 50)) : null
          });
          
          const positionText = errorPosition ? ` Posición: ${errorPosition}` : '';
          throw new Error(`Error al parsear la respuesta JSON de traducción: ${e.message}.${positionText}`);
        }

        if (changeslug || !parsedResponse.link || parsedResponse.link === '') {
          console.log("Entró a cambiar el slug, se cambia el slug");
          parsedResponse.link = `https://www.explore-share.com/${
            toLanguage.split('_')[0]
          }/trip/${slugify(parsedResponse.title).toLowerCase()}/`;
        } else {
          console.log("No entró a cambiar el slug, se mantiene el original");
          parsedResponse.link = originalLink.endsWith('/') ? originalLink : `${originalLink}/`;
        }

        delete parsedResponse.temp_slug;

        const finalData = {
          _id: trip._id,  
          i18n: {
            ...trip.i18n,
            [toLanguage]: parsedResponse
          },
          'sync_status.i18n': 'WAITING_PUBLISHED'
        };

        await usePatchTrip(finalData);

        page.success = true;
        page.url = parsedResponse.link;
        setCsvStatics((prev) => ({ ...prev, success: (prev.success || 0) + 1 }));
      } catch (e) {
        page.success = false;
        const errorMessage = `Trip (ID: ${page._id || 'N/A'}) - ${e.message || 'error desconocido'}`;
        page.comment = e.message || 'error desconocido';
        setCsvStatics((prev) => ({ 
          ...prev, 
          error: (prev.error || 0) + 1,
          errorMessages: [...(prev.errorMessages || []), errorMessage]
        }));
        console.log(e);
      }
    }

    console.log('Resultado del procesamiento:', bulk);
    setTranslating(false);
    window.onbeforeunload = null;
  };

  useEffect(() => {
    if (!fromLanguage || !toLanguage) return;
    try {
      refetch({ throwOnError: true }).then(({ data }) => setGlossary(data.value));
    } catch (e) {}
  }, [fromLanguage, toLanguage]);

  const handleChange = (event, newValue) => {
    setOpenOptions(newValue);
  };

  const handleUploadFile = (e) => {
    console.log(e.target.files);

    var reader = new FileReader();
    reader.onload = function (progressEvent) {
      const text = this.result;

      var lines = text.split('\n');
      lines.shift();

      /** limpieza del archivo csv */
      const cleanedLines = lines
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      const bulkItems = cleanedLines.map((item) => {
        return { _id: item.trim() };
      });

      setBulk(bulkItems);
      setCsvStatics({ count: bulkItems.length });
    };
    reader.readAsText(e.target.files[0]);
  };

  return (
    <Drawer
      size="md"
      variant="plain"
      open={open}
      onClose={() => {
        if (!translating) {
          setOpen(false);
        }
      }}
      slotProps={{
        content: {
          sx: {
            bgcolor: 'transparent',
            p: { md: 3, sm: 0 },
            boxShadow: 'none'
          }
        }
      }}>
      <Sheet
        sx={{
          borderRadius: 'md',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          height: '100%',
          overflow: 'auto'
        }}>
        <DialogTitle>Bulk Action</DialogTitle>
        <ModalClose />

        {bulkPage.length ? (
          <List>
            {bulkPage.map((item) => (
              <ListItem
                endAction={
                  <Button size="sm">
                    <DeleteForever />
                  </Button>
                }>
                {item.title}
              </ListItem>
            ))}
          </List>
        ) : (
          <>
            <Typography level="body-sm">Upload a csv with _id column (need header)</Typography>
            <Button
              component="label"
              role={undefined}
              tabIndex={-1}
              variant="outlined"
              color="neutral"
              startDecorator={
                <SvgIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                    />
                  </svg>
                </SvgIcon>
              }>
              Upload a file
              <Input
                type="file"
                onChange={handleUploadFile}
                sx={{
                  clip: 'rect(0 0 0 0)',
                  clipPath: 'inset(50%)',
                  height: '1px',
                  overflow: 'hidden',
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  whiteSpace: 'nowrap',
                  width: '1px'
                }}
              />
            </Button>
            {csvStatics.count ? (
              <Typography color="neutral">Rows found {csvStatics.count}</Typography>
            ) : null}
            {csvStatics.success ? (
              <Typography color="success">Rows success {csvStatics.success}</Typography>
            ) : null}
            {csvStatics.error ? (
              <>
                <Typography color="danger">Rows fail {csvStatics.error}</Typography>
                {csvStatics.errorMessages && csvStatics.errorMessages.length > 0 && (
                  <Stack spacing={0.5} sx={{ mt: 1 }}>
                    {csvStatics.errorMessages.map((errorMsg, index) => (
                      <Typography
                        key={index}
                        sx={{
                          bgcolor: '#ef4444',
                          color: 'white',
                          p: 1,
                          borderRadius: 'sm',
                          fontSize: '1rem',
                          fontWeight: 600
                        }}>
                        {errorMsg}
                      </Typography>
                    ))}
                  </Stack>
                )}
              </>
            ) : null}
            {csvStatics.infoMessages && csvStatics.infoMessages.length > 0 && (
              <Stack spacing={0.5} sx={{ mt: 1 }}>
                {csvStatics.infoMessages.map((infoMsg, index) => (
                  <Typography
                    key={index}
                    sx={{
                      bgcolor: '#fd7e14',
                      color: 'white',
                      p: 1,
                      borderRadius: 'sm',
                      fontSize: '1rem',
                      fontWeight: 600
                    }}>
                    {infoMsg}
                  </Typography>
                ))}
              </Stack>
            )}
          </>
        )}

        <Divider sx={{ mt: 'auto' }} />
        <Stack direction="column" justifyContent="space-between" useFlexGap spacing={1}>
          <Select placeholder="Choose one…" onChange={handleChange}>
            {actions.map((item) => (
              <Option value={item.value}>{item.label}</Option>
            ))}
          </Select>

          {openOptions === 'translate' && (
            <>
              <Stack direction="row" justifyContent="space-between" gap={2}>
                <Select
                  defaultValue={DEFAULT_LOCALE}
                  sx={{ flex: 1 }}
                  placeholder="Translate From .."
                  onChange={(event, newValue) => setFromLanguage(newValue)}>
                  {Object.entries(LOCALES_SHORT).map((item) => (
                    <Option value={item[0]}>{item[1]}</Option>
                  ))}
                </Select>

                <Select
                  sx={{ flex: 1 }}
                  placeholder="Translate to .."
                  onChange={(event, newValue) => setToLanguage(newValue)}>
                  {Object.entries(LOCALES_SHORT).map((item) =>
                    DEFAULT_LOCALE !== item[0] ? <Option value={item[0]}>{item[1]}</Option> : null
                  )}
                </Select>
              </Stack>

              <FormControl>
                <Checkbox
                  label="Overwrite translation"
                  size="sm"
                  color="danger"
                  onChange={(event) => setChangecontent(event.target.checked)}
                />
              </FormControl>

              {!changecontent ? (
                <FormHelperText level="body-xs">
                  If you check this option, the translator will ignore pre-existing content.
                </FormHelperText>
              ) : (
                <FormHelperText level="body-xs">
                  <Input
                    placeholder="type `overwrite` for confirmation"
                    onChange={(event) =>
                      setChangecontentConfirmed(event.target.value === 'overwrite')
                    }
                  />
                </FormHelperText>
              )}

              {changecontentConfirmed ? (
                <FormControl>
                  <Checkbox
                    label="Change slug"
                    size="sm"
                    color="danger"
                    onChange={(event) => setChangeslug(event.target.checked)}
                  />
                  <FormHelperText level="body-xs">
                    If you check this option, the slug and URL will be changed.
                  </FormHelperText>
                </FormControl>
              ) : null}
            </>
          )}

          <Button onClick={() => handleTranslate()} loading={translating}>
            Run
          </Button>
        </Stack>
      </Sheet>
    </Drawer>
  );
};

export default TripBulk;
